import Vue from "vue";
import Router from "vue-router";

import Dashboard from "./views/Dashboard.vue";
import ClientDashboard from "./views/ClientDashboard.vue";

import Offices from "./views/offices/Offices.vue";
import Office from "./views/offices/Office.vue";

import Positions from "./views/positions/Positions.vue";
import Position from "./views/positions/Position.vue";

import Countries from "./views/countries/Countries.vue";
import Country from "./views/countries/Country.vue";

import ActivityTypes from "./views/activity-types/ActivityTypes.vue";
import ActivityType from "./views/activity-types/ActivityType.vue";

import Currencies from "./views/currencies/Currencies.vue";
import Currency from "./views/currencies/Currency.vue";

import Employees from "./views/employees/Employees.vue";
import Employee from "./views/employees/Employee.vue";

import Regions from "./views/regions/Regions.vue";
import Region from "./views/regions/Region.vue";

import Cities from "./views/cities/Cities.vue";
import City from "./views/cities/City.vue";

import Addresses from "./views/addresses/Addresses.vue";
import Address from "./views/addresses/Address.vue";

import Warehouses from "./views/warehouses/Warehouses.vue";
import Warehouse from "./views/warehouses/Warehouse.vue";

import Clients from "./views/clients/Clients.vue";
import Client from "./views/clients/Client.vue";

import RollingStockTypes from "./views/rolling-stock-types/RollingStockTypes.vue";
import RollingStockType from "./views/rolling-stock-types/RollingStockType.vue";

import Factories from "./views/factories/Factories.vue";
import Factory from "./views/factories/Factory.vue";

import Manufacturers from "./views/manufacturers/Manufacturers.vue";
import Manufacturer from "./views/manufacturers/Manufacturer.vue";

import ContactPersons from "./views/contact-persons/ContactPersons.vue";
import ContactPerson from "./views/contact-persons/ContactPerson.vue";

import Carriers from "./views/carriers/Carriers.vue";
import Carrier from "./views/carriers/Carrier.vue";

import Vehicles from "./views/vehicles/Vehicles.vue";
import Vehicle from "./views/vehicles/Vehicle.vue";

import Drivers from "./views/drivers/Drivers.vue";
import Driver from "./views/drivers/Driver.vue";

import RollingStocks from "./views/rolling-stocks/RollingStocks.vue";
import RollingStock from "./views/rolling-stocks/RollingStock.vue";

import ShipmentRequests from "./views/shipment-requests/ShipmentRequests.vue";
import ShipmentRequest from "./views/shipment-requests/ShipmentRequest.vue";
import NewRequest from "./views/shipment-requests/NewRequest.vue";
import ShipmentRequestDrafts from "./views/shipment-requests/Drafts.vue";

import ProductCategories from "./views/product-categories/ProductCategories.vue";
import ProductCategory from "./views/product-categories/ProductCategory.vue";

import Users from "./views/users/Users.vue";
import User from "./views/users/User.vue";

import Units from "./views/units/Units.vue";
import Unit from "./views/units/Unit.vue";

import Shippings from "./views/shippings/Shipings.vue";
import Shipping from "./views/shippings/Shipping.vue";
import NewShipping from "./views/shippings/components/new-shipping/NewShipping.vue";

import ShippingDrafts from "./views/shippings/Drafts.vue";

import Trademarks from "./views/trademarks/Trademarks.vue";
import Trademark from "./views/trademarks/Trademark.vue";

import TrademarkModels from "./views/trademark-models/TrademarkModels.vue";
import TrademarkModel from "./views/trademark-models/TrademarkModel.vue";

import Nomenclatures from "./views/nomenclatures/Nomenclatures.vue";
import Nomenclature from "./views/nomenclatures/Nomenclature.vue";

import Articles from "./views/articles/Articles.vue";
import Article from "./views/articles/Article.vue";

import GoodsDetailsList from "./views/goods-details/GoodsDetailsList.vue";
import GoodsDetails from "./views/goods-details/GoodsDetails.vue";

import Routes from "./views/routes/Routes.vue";
import Route from "./views/routes/Route.vue";

import CustomsEntryRegistrations from "./views/customs-entry-registrations/CustomsEntryRegistrations.vue";
import CustomsEntryRegistration from "./views/customs-entry-registrations/CustomsEntryRegistration.vue";

import Forwarders from "./views/forwarders/Forwarders.vue";
import Forwarder from "./views/forwarders/Forwarder.vue";

import RoutesPlanning2 from "./views/routes-planning/RoutesPlanning.vue";

import auth from "./auth.js";

import OldVersion_WarehouseDetails from "./views/old-version-warehouse/OldVersion_WarehouseDetails.vue";
import WarehouseDetails from "./views/shippings-in-warehouse/WarehouseDetails.vue";

import Settings from "./views/settings/Settings.vue";

import ImportClients from "./views/import/clients/ImportClients.vue";
import ClientsDrafts from "./views/import/clients/ClientsDrafts.vue";
import ClientDraft from "./views/import/clients/ClientDraft.vue";

import ImportFactories from "./views/import/factories/ImportFactories.vue";
import FactoriesDrafts from "./views/import/factories/FactoriesDrafts.vue";
import FactoryDraft from "./views/import/factories/FactoryDraft.vue";

import ImportLocations from "./views/import/locations/ImportLocations.vue";

import UsersPermissions from "./views/UsersPermissions.vue";

import Districts from "./views/districts/Districts.vue";
import District from "./views/districts/District.vue";

import ImportDetails from "./views/import/goods/ImportGoods.vue";
import GoodsDrafts from "./views/import/goods/GoodsDrafts.vue";

import ReleaseOrders from "./views/release-orders/ReleaseOrders.vue";
import ReleaseOrder from "./views/release-orders/ReleaseOrder.vue";

import GoodsTypes from "./views/goods-types/GoodsTypes.vue";
import GoodsType from "./views/goods-types/GoodsType.vue";

import Tariffs from "./views/tariffs/Tariffs.vue";
import Tariff from "./views/tariffs/Tariff.vue";

import Location from "./views/locations/Location.vue";
import Locations from "./views/locations/Locations.vue";

import CourierServices from "./views/courier-service/CourierServices.vue";
import CourierService from "./views/courier-service/CourierService.vue";

import ImportShippingReleaseApprovement from "./views/import/release-orders/ImportShippingReleaseApprovement.vue";

import PackageTypes from "./views/package-types/PackageTypes.vue";
import PackageType from "./views/package-types/PackageType.vue";

import CabinetUser from "./views/cabinet-users/CabinetUser.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
        title: "Рабочий Стол",
      },
    },
    {
      path: "/client-dashboard",
      name: "client-dashboard",
      component: ClientDashboard,
      meta: {
        requiresAuth: true,
        title: "Рабочий Стол",
      },
    },
    {
      path: "/",
      name: "home",
      redirect: () => {
        if (auth.loggedIn()) {
          if (auth.getUser().isClient) {
            return { name: "client-dashboard" };
          }
          return { name: "dashboard" };
        }
      },
    },
    {
      path: "/offices",
      name: "offices",
      component: Offices,
      props: true,
      meta: { requiresAuth: true, title: "Офисы" },
    },
    {
      path: "/offices/:id",
      name: "office",
      component: Office,
      props: true,
      meta: { requiresAuth: true, title: "Офисы" },
    },
    {
      path: "/activity-types",
      name: "activity-types",
      component: ActivityTypes,
      props: true,
      meta: { requiresAuth: true, title: "Роды Деятельности" },
    },
    {
      path: "/activity-types/:id",
      name: "activity-type",
      component: ActivityType,
      props: true,
      meta: { requiresAuth: true, title: "Роды Деятельности" },
    },
    {
      path: "/cities",
      name: "cities",
      component: Cities,
      props: true,
      meta: { requiresAuth: true, title: "Города" },
    },
    {
      path: "/cities/:id",
      name: "city",
      component: City,
      props: true,
      meta: { requiresAuth: true, title: "Города" },
    },
    {
      path: "/addresses",
      name: "addresses",
      component: Addresses,
      props: true,
      meta: { requiresAuth: true, title: "Адреса" },
    },
    {
      path: "/addresses/:id",
      name: "address",
      component: Address,
      props: true,
      meta: { requiresAuth: true, title: "Адреса" },
    },
    {
      path: "/countries",
      name: "countries",
      component: Countries,
      props: true,
      meta: { requiresAuth: true, title: "Страны" },
    },
    {
      path: "/countries/:id",
      name: "country",
      component: Country,
      props: true,
      meta: { requiresAuth: true, title: "Страны" },
    },
    {
      path: "/currencies",
      name: "currencies",
      component: Currencies,
      props: true,
      meta: { requiresAuth: true, title: "Валюты" },
    },
    {
      path: "/currencies/:id",
      name: "currency",
      component: Currency,
      props: true,
      meta: { requiresAuth: true, title: "Валюты" },
    },
    {
      path: "/positions",
      name: "positions",
      component: Positions,
      props: true,
      meta: { requiresAuth: true, title: "Должности" },
    },
    {
      path: "/positions/:id",
      name: "position",
      component: Position,
      props: true,
      meta: { requiresAuth: true, title: "Должности" },
    },
    {
      path: "/regions",
      name: "regions",
      component: Regions,
      props: true,
      meta: { title: "Регионы" },
    },
    {
      path: "/regions/:id",
      name: "region",
      component: Region,
      props: true,
      meta: { requiresAuth: true, title: "Регионы" },
    },
    {
      path: "/districts",
      name: "districts",
      component: Districts,
      props: true,
      meta: { title: "Области" },
    },
    {
      path: "/districts/:id",
      name: "district",
      component: District,
      props: true,
      meta: { requiresAuth: true, title: "Области" },
    },
    {
      path: "/warehouses",
      name: "warehouses",
      component: Warehouses,
      props: true,
      meta: { requiresAuth: true, title: "Склады" },
    },
    {
      path: "/warehouses/:id",
      name: "warehouse",
      component: Warehouse,
      props: true,
      meta: { requiresAuth: true, title: "Склады" },
    },
    {
      path: "/employees",
      name: "employees",
      component: Employees,
      props: true,
      meta: { requiresAuth: true, title: "Сотрудники" },
    },
    {
      path: "/employees/:id",
      name: "employee",
      component: Employee,
      props: true,
      meta: { requiresAuth: true, title: "Сотрудники" },
    },
    {
      path: "/clients",
      name: "clients",
      component: Clients,
      props: true,
      meta: { requiresAuth: true, title: "Клиенты" },
    },
    {
      path: "/clients/:id",
      name: "client",
      component: Client,
      props: true,
      meta: { requiresAuth: true, title: "Клиенты" },
    },
    {
      path: "/factories",
      name: "factories",
      component: Factories,
      props: true,
      meta: { requiresAuth: true, title: "Продавцы" },
    },
    {
      path: "/factories/:id",
      name: "factory",
      component: Factory,
      props: true,
      meta: { requiresAuth: true, title: "Продавцы" },
    },
    {
      path: "/manufacturers",
      name: "manufacturers",
      component: Manufacturers,
      props: true,
      meta: { requiresAuth: true, title: "Производители" },
    },
    {
      path: "/manufacturers/:id",
      name: "manufacturer",
      component: Manufacturer,
      props: true,
      meta: { requiresAuth: true, title: "Производители" },
    },
    {
      path: "/contact-persons",
      name: "contact-persons",
      component: ContactPersons,
      props: true,
      meta: { requiresAuth: true, title: "Контактные Лица" },
    },
    {
      path: "/contact-persons/:id",
      name: "contact-person",
      component: ContactPerson,
      props: true,
      meta: { requiresAuth: true, title: "Контактные Лица" },
    },
    {
      path: "/rolling-stock-types",
      name: "rolling-stock-types",
      component: RollingStockTypes,
      props: true,
      meta: { requiresAuth: true, title: "Типы Подвижного Состава" },
    },
    {
      path: "/rolling-stock-types/:id",
      name: "rolling-stock-type",
      component: RollingStockType,
      props: true,
      meta: { requiresAuth: true, title: "Типы Подвижного Состава" },
    },
    {
      path: "/carriers",
      name: "carriers",
      component: Carriers,
      props: true,
      meta: { requiresAuth: true, title: "Перевозчики" },
    },
    {
      path: "/carriers/:id",
      name: "carrier",
      component: Carrier,
      props: true,
      meta: { requiresAuth: true, title: "Перевозчики" },
    },
    {
      path: "/vehicles",
      name: "vehicles",
      component: Vehicles,
      props: true,
      meta: { requiresAuth: true, title: "Машины" },
    },
    {
      path: "/vehicles/:id",
      name: "vehicle",
      component: Vehicle,
      props: true,
      meta: { requiresAuth: true, title: "Машины" },
    },
    {
      path: "/drivers",
      name: "drivers",
      component: Drivers,
      props: true,
      meta: { requiresAuth: true, title: "Водители" },
    },
    {
      path: "/drivers/:id",
      name: "driver",
      component: Driver,
      props: true,
      meta: { requiresAuth: true, title: "Водители" },
    },
    {
      path: "/rolling-stocks",
      name: "rolling-stocks",
      component: RollingStocks,
      props: true,
      meta: { requiresAuth: true, title: "Подвижной Состав" },
    },
    {
      path: "/rolling-stocks/:id",
      name: "rolling-stock",
      component: RollingStock,
      props: true,
      meta: { requiresAuth: true, title: "Подвижной Состав" },
    },
    {
      path: "/shipment-requests",
      name: "shipment-requests",
      component: ShipmentRequests,
      meta: { requiresAuth: true, title: "Запросы" },
    },
    {
      path: "/shipment-requests/new",
      name: "shipment-request-new",
      component: NewRequest,
      props: true,
      meta: { requiresAuth: true, title: "Создание Запроса" },
    },
    {
      path: "/shipment-requests/:id",
      name: "shipment-request",
      component: ShipmentRequest,
      props: true,
      meta: { requiresAuth: true, title: "Запросы" },
    },
    {
      path: "/shipment-request-drafts",
      name: "shipment-request-drafts",
      component: ShipmentRequestDrafts,
      meta: { requiresAuth: true, title: "Запросы Черновики" },
    },
    {
      path: "/product-categories",
      name: "product-categories",
      component: ProductCategories,
      props: true,
      meta: { requiresAuth: true, title: "Категории Товаров" },
    },
    {
      path: "/product-categories/:id",
      name: "product-category",
      component: ProductCategory,
      props: true,
      meta: { requiresAuth: true, title: "Категории Товаров" },
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: { requiresAuth: true, title: "Пользователи" },
    },
    {
      path: "/users/:id",
      name: "user",
      component: User,
      props: true,
      meta: { requiresAuth: true, title: "Пользователи", permissions: "users" },
    },
    {
      path: "/units",
      name: "units",
      component: Units,
      props: true,
      meta: { requiresAuth: true, title: "Единицы Измерения" },
    },
    {
      path: "/units/:id",
      name: "unit",
      component: Unit,
      props: true,
      meta: { requiresAuth: true, title: "Единицы Измерения" },
    },
    {
      path: "/shippings",
      name: "shippings",
      component: Shippings,
      meta: { requiresAuth: true, title: "Поставки" },
    },
    {
      path: "/shippings/new",
      name: "shipping-new-steps",
      component: NewShipping,
      meta: { requiresAuth: true, title: "Создание Поставки" },
      props: true,
    },
    {
      path: "/shippings/:id",
      name: "shipping",
      component: Shipping,
      props: true,
      meta: { requiresAuth: true, title: "Поставки" },
    },
    {
      path: "/shipping-drafts",
      name: "shipping-drafts",
      component: ShippingDrafts,
      meta: { requiresAuth: true, title: "Поставки Черновики" },
    },
    {
      path: "/trademarks",
      name: "trademarks",
      component: Trademarks,
      props: true,
      meta: { requiresAuth: true, title: "Торговые Марки" },
    },
    {
      path: "/trademarks/:id",
      name: "trademark",
      component: Trademark,
      props: true,
      meta: { requiresAuth: true, title: "Торговые Марки" },
    },
    {
      path: "/trademark-models",
      name: "trademark-models",
      component: TrademarkModels,
      props: true,
      meta: { requiresAuth: true, title: "Модели ТМ" },
    },
    {
      path: "/trademark-models/:id",
      name: "trademark-model",
      component: TrademarkModel,
      props: true,
      meta: { requiresAuth: true, title: "Модели ТМ" },
    },
    {
      path: "/nomenclatures",
      name: "nomenclatures",
      component: Nomenclatures,
      props: true,
      meta: { requiresAuth: true, title: "Номенклатуры" },
    },
    {
      path: "/nomenclatures/:id",
      name: "nomenclature",
      component: Nomenclature,
      props: true,
      meta: { requiresAuth: true, title: "Номенклатуры" },
    },
    {
      path: "/articles",
      name: "articles",
      component: Articles,
      props: true,
      meta: { requiresAuth: true, title: "Артикулы" },
    },
    {
      path: "/articles/:id",
      name: "article",
      component: Article,
      props: true,
      meta: { requiresAuth: true, title: "Артикулы" },
    },
    {
      path: "/goods-details",
      name: "goods-details-list",
      component: GoodsDetailsList,
      meta: { requiresAuth: true, title: "Описание Товаров" },
    },
    {
      path: "/goods-details/:id",
      name: "goods-details",
      component: GoodsDetails,
      props: true,
      meta: { requiresAuth: true, title: "Описание Товаров" },
    },
    {
      path: "/routes",
      name: "routes",
      component: Routes,
      meta: { requiresAuth: true, title: "Маршруты" },
    },
    {
      path: "/routes/:id",
      name: "route",
      component: Route,
      props: true,
      meta: { requiresAuth: true, title: "Маршруты" },
    },
    {
      path: "/customs-entry-registrations",
      name: "customs-entry-registrations",
      component: CustomsEntryRegistrations,
      props: true,
      meta: { requiresAuth: true, title: "Затаможка" },
    },
    {
      path: "/customs-entry-registrations/:id",
      name: "customs-entry-registration",
      component: CustomsEntryRegistration,
      props: true,
      meta: { requiresAuth: true, title: "Затаможка" },
    },
    {
      path: "/routes-planning",
      name: "routes-planning",
      component: RoutesPlanning2,
      meta: { requiresAuth: true, title: "Планирование Маршрутов 2" },
    },
    {
      path: "/forwarders/:id",
      name: "forwarder",
      component: Forwarder,
      props: true,
      meta: { requiresAuth: true, title: "Экспедиторы" },
    },
    {
      path: "/forwarders",
      name: "forwarders",
      component: Forwarders,
      props: true,
      meta: { requiresAuth: true, title: "Экспедиторы" },
    },
    {
      path: "/old-version-warehouse-details",
      name: "old-version-warehouse-details",
      component: OldVersion_WarehouseDetails,
      meta: { requiresAuth: true, title: "Старая версия_Склад" },
    },
    {
      path: "/warehouse-details",
      name: "warehouse-details",
      component: WarehouseDetails,
      meta: { requiresAuth: true, title: "Склад" },
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: { requiresAuth: true, title: "Настройки" },
    },
    {
      path: "/import-clients",
      name: "import-clients",
      component: ImportClients,
      meta: { requiresAuth: true, title: "Импорт Клиенты" },
    },
    {
      path: "/clients-drafts",
      name: "clients-drafts",
      component: ClientsDrafts,
      meta: { requiresAuth: true, title: "Импорт Клиенты Черновики" },
    },
    {
      path: "/clients-drafts/:id",
      name: "client-draft",
      component: ClientDraft,
      props: true,
      meta: { requiresAuth: true, title: "Импорт Клиенты Черновики" },
    },
    {
      path: "/import-factories",
      name: "import-factories",
      component: ImportFactories,
      meta: { requiresAuth: true, title: "Импорт Фабрики" },
    },
    {
      path: "/factories-drafts",
      name: "factories-drafts",
      component: FactoriesDrafts,
      meta: { requiresAuth: true, title: "Импорт Продавцы Черновики" },
    },
    {
      path: "/factories-drafts/:id",
      name: "factory-draft",
      component: FactoryDraft,
      props: true,
      meta: { requiresAuth: true, title: "Импорт Продавцы Черновики" },
    },
    {
      path: "/import-locations",
      name: "import-locations",
      component: ImportLocations,
      meta: { requiresAuth: true, title: "Импорт Базы Адресов" },
    },
    {
      path: "/users-permissions",
      name: "users-permissions",
      component: UsersPermissions,
      meta: {
        requiresAuth: true,
        title: "Параметры доступа",
      },
    },
    {
      path: "/import-goods",
      name: "import-goods",
      component: ImportDetails,
      meta: { requiresAuth: true, title: "Импорт Описание товаров" },
    },
    {
      path: "/goods-drafts",
      name: "goods-drafts",
      component: GoodsDrafts,
      meta: { requiresAuth: true, title: "Импорт Описание товаров Черновики" },
    },
    {
      path: "/release-orders",
      name: "release-orders",
      component: ReleaseOrders,
      meta: { requiresAuth: true, title: "Отгрузки" },
    },
    {
      path: "/release-orders/:id",
      name: "release-order",
      component: ReleaseOrder,
      props: true,
      meta: { requiresAuth: true, title: "Отгрузки" },
    },
    {
      path: "/goods-types",
      name: "goods-types",
      component: GoodsTypes,
      props: true,
      meta: { requiresAuth: true, title: "Типы товара" },
    },
    {
      path: "/goods-types/:id",
      name: "goods-type",
      component: GoodsType,
      props: true,
      meta: { requiresAuth: true, title: "Типы товара" },
    },
    {
      path: "/tariffs",
      name: "tariffs",
      component: Tariffs,
      props: true,
      meta: { requiresAuth: true, title: "Тарифы" },
    },
    {
      path: "/tariffs/:id",
      name: "tariff",
      component: Tariff,
      props: true,
      meta: { requiresAuth: true, title: "Тарифы" },
    },
    {
      path: "/locations",
      name: "locations",
      component: Locations,
      props: true,
      meta: { requiresAuth: true, title: "Индексы" },
    },
    {
      path: "/locations/:id",
      name: "location",
      component: Location,
      props: true,
      meta: { requiresAuth: true, title: "Индексы" },
    },
    {
      path: "/courier-services",
      name: "courier-services",
      component: CourierServices,
      props: true,
      meta: { requiresAuth: true, title: "Курьерские службы" },
    },
    {
      path: "/courier-services/:id",
      name: "courier-service",
      component: CourierService,
      props: true,
      meta: { requiresAuth: true, title: "Курьерские службы" },
    },
    {
      path: "/import-shipping-release-approvement",
      name: "import-shipping-release-approvement",
      component: ImportShippingReleaseApprovement,
      props: true,
      meta: { requiresAuth: true, title: "Разрешение на отгрузку" },
    },
    {
      path: "/package-types",
      name: "package-types",
      component: PackageTypes,
      props: true,
      meta: { requiresAuth: true, title: "Типы упаковок" },
    },
    {
      path: "/package-types/:id",
      name: "package-type",
      component: PackageType,
      props: true,
      meta: {
        requiresAuth: true, title: "Тип упаковки",
      },
    },
    {
      path: "/cabinet-users/new",
      name: "cabinet-users",
      component: CabinetUser,
      props: true,
      meta: {
        requiresAuth: true, title: "Пользователи Кабинета Клиентов",
      },
    },
  ],
});
